import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08389dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "announcement-carousal" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]

import DxGallery from "devextreme-vue/gallery";
import { HomepageAnnouncement } from "@/types/announcements/home-page-announcement";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { onMounted, ref, inject } from "vue";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import InfoCard from "@/components/ui/containers/info-card.vue";
import AnnouncementModal from "./announcement-modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'announcements-card',
  props: {
  /**
   * The width of the card to ensure it fits correctly in the home page quadrent.
   * @type {string}
   * @default 100%
   */
  width: {
    type: String,
    default: "100%",
  },
},
  setup(__props) {

const props = __props;



const announcements = ref<HomepageAnnouncement[]>([]);
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const displayAnnouncementModal = ref(false);
const anouncementModalId = ref(0);

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
  fetchAnnouncements();
});

const fetchAnnouncements = async () => {
  try {
    announcements.value = await apiClient.httpGet<HomepageAnnouncement[]>(
      `app/user/announcements/${currentUser.value?.id}`,
    );
  } catch (error) {
    displayErrorMessage(getErrorMessage(error));
    announcements.value = [];
  }
};

// If a user has expressed interest, or a lack, of an announcement, the announcements displayed will be refreshed.
const announcementModalClosed = (interestExpressed: boolean) => {
  if (interestExpressed) {
    fetchAnnouncements();
  }
};

const appointmentClicked = (announcementId: number) => {
  anouncementModalId.value = announcementId;
  displayAnnouncementModal.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (announcements.value.length > 0)
      ? (_openBlock(), _createBlock(InfoCard, {
          key: 0,
          title: "Announcements",
          width: props.width
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(DxGallery), {
                id: "gallery",
                dataSource: announcements.value,
                loop: true,
                "show-nav-buttons": true,
                "show-indicator": true,
                width: "100%",
                height: "100%",
                "item-template": "item",
                slideshowDelay: "10000"
              }, {
                item: _withCtx(({ data }) => [
                  _createElementVNode("div", {
                    class: "picture-holder",
                    onClick: ($event: any) => (appointmentClicked(data.id))
                  }, [
                    _createElementVNode("img", {
                      src: data.imageUrl
                    }, null, 8, _hoisted_3)
                  ], 8, _hoisted_2)
                ]),
                _: 1
              }, 8, ["dataSource"])
            ])
          ]),
          _: 1
        }, 8, ["width"]))
      : _createCommentVNode("", true),
    _createVNode(AnnouncementModal, {
      modelValue: displayAnnouncementModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayAnnouncementModal).value = $event)),
      onModalClosed: announcementModalClosed,
      clickedAnnouncementId: anouncementModalId.value
    }, null, 8, ["modelValue", "clickedAnnouncementId"])
  ], 64))
}
}

})